import { Injectable } from '@angular/core';
import { LU_VehicleTypeServiceBase } from 'scaletech-vehicles';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class LU_VehicleTypeService extends LU_VehicleTypeServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
